<footer class="site-footer">
  <mat-divider />
  <div class="footer-container">
    <p class="footer-text">© {{ currentYear }} Hane. Todos los derechos reservados.</p>
    <p class="footer-subtitle">Hecho con Angular ❤️</p>
  </div>
</footer>
